import { AlertMessage } from "./shared/components"

type MainErrorProps = {
  onRestart: () => void
}
export function MainError({ onRestart }: MainErrorProps) {
  return (
    <div className="mx-8 my-4 ta-c">
      <AlertMessage>
        Something unexpected happened. Please try again.
      </AlertMessage>
      <button className="secondary-btn btn mb-3 mt-3" onClick={onRestart}>
        Start over
      </button>
    </div>
  )
}
